import { createRoot } from 'react-dom/client'

import { Root } from './Root'

createRoot(document.querySelector('#root')!).render(<Root />)
